import { render } from "./ConfirmList.vue?vue&type=template&id=c2f991c8&scoped=true"
import script from "./ConfirmList.vue?vue&type=script&lang=js"
export * from "./ConfirmList.vue?vue&type=script&lang=js"

import "./ConfirmList.vue?vue&type=style&index=0&id=c2f991c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bert\\Documents\\Projects\\v-tax-chauffeurs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2f991c8"]])

export default __exports__